import {useEffect} from "react";
import CryptoJS from "crypto-js";

/**
 * 2CHERO intro page
 * https://www.bizting.co.kr/hosting/2chero/intro
 * */
const Hosting2CHEROIntro = () => {
    useEffect(() => {
        window.sessionStorage.setItem('adSrc', 'eyAiYWRQYXRoIiA6ICAiQ0hFUk8ifQ==');

        const state = {
            hostType: 'CHERO',
        };

        let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

        let url = `${process.env.REACT_APP_DEFAULT_INTRO_REDIRECT_URI}`;
        url += `?state=${encryptedState}`;

        window.location.href = url;
    }, []);
};

export default Hosting2CHEROIntro;
